import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
// import JwtHelper from '@/helpers/jwtHelper'
// import ZendeskService from '@/services/zendesk'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   name: 'dashboard',
    //   component: () => import('@/views/Dashboard'),
    //   redirect: { name: 'my-pages' },
    //   children: [
    //     {
    //       path: 'my-pages',
    //       name: 'my-pages',
    //       component: () => import('@/views/Dashboard/PagesList.vue'),
    //     },
    //     {
    //       path: 'choice-theme',
    //       name: 'choice-theme',
    //       component: () => import('@/views/Dashboard/ChoiceTheme.vue'),
    //     },
    //     {
    //       path: 'themes',
    //       name: 'themes',
    //       beforeEnter: (to, from, next) => {
    //         if (JwtHelper.isAdmin()) next()
    //         else next({ name: 'my-pages' })
    //       },
    //       component: () => import('@/views/Dashboard/Themes'),
    //     },
    //   ],
    // },
    {
      path: '/editor',
      name: 'editor',
      component: {
        template: '<router-view></router-view>',
      },
      beforeEnter: async (to, _from, next) => {
        try {
          await store.dispatch('landing/getLanding', to.params.id)
          next()
        } catch (err) {
          next('/error/404')
        }
      },
      children: [
        {
          path: ':id',
          name: 'page',
          component: () => import('@/views/PageEditor'),
          props: true,
        },
        {
          path: ':id/preview',
          name: 'preview',
          component: () => import('@/views/Preview.vue'),
          props: true,
        },
      ],
    },
    {
      path: '/error/:code',
      name: 'error',
      component: () => import('@/views/ErrorPage.vue'),
      props: true,
    },
    { path: '**', redirect: '/error/404' },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'error' && store.state.ui.error.code !== null) {
    next({ name: 'error', params: { code: '403' } })
  }

  next()
})

router.afterEach((to, from, next) => {
  // const {
  //   user: { name, email },
  // } = JwtHelper.payload
  // ZendeskService.identify(name, email)

  if (window.Appcues) {
    window.Appcues.page()
  }
})

export default router
